// extracted by mini-css-extract-plugin
export var optionGrid = "_5a-7";
export var optionList = "_5a-6";
export var questionsBlock = "_5a-9";
export var spacer = "_5a-5";
export var stepCenteredContent = "_5a-3";
export var stepInner = "_5a-0";
export var stepInnerFullWidth = "_5a-1";
export var stepInnerLockScroll = "_5a-2";
export var stepTransitionFrame = "_5a-4";
export var welcomeBlock = "_5a-8";